import { createIdentityClient, setIdentityClient } from '@sdc/auth';

/**
 * Identity-Client explizit konfigurieren.
 *
 * Bewusst nicht der Env-Automatik von `@sdc/auth` ueberlassen: die Werte werden
 * hier aus dem **statischen** `import.meta.env` gelesen, das Vite garantiert
 * ersetzt. Damit haengt der Start des Hubs nicht daran, ob eine Library in ihrem
 * kompilierten Zustand noch an die Env-Vars kommt – genau daran lag der Fehler,
 * der die Seite komplett leer gelassen hat.
 */
export function initIdentity(): void {
  setIdentityClient(
    createIdentityClient({
      url: import.meta.env.VITE_IDENTITY_URL as string,
      anonKey: import.meta.env.VITE_IDENTITY_ANON_KEY as string,
    }),
  );
}
